export default __webpack_public_path__ + "static/media/slider3.27b0be1d.jpg";